export function max<T extends number>(...args: T[]): T {
  return Math.max(...args) as T;
}

export function min<T extends number>(...args: T[]): T {
  return Math.min(...args) as T;
}
